// 巡检记录
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Card, theme, Checkbox, Tabs, Pagination, Spin, Button, Tag, Empty, Modal, App, Drawer, Image } from 'antd'
import { ArrowLeftOutlined, PlusOutlined, EnvironmentFilled } from '@ant-design/icons'
import ImageCom from "@/component/ImageCom/index.js"//图片显示组件
import { transformGCJ2WGS } from "@/common/js/common.js" //引入公共方法
import { basicPath } from '@/router/config';//引入路由基础路径
import ai_processing from '@/common/img/ai_processing.svg'
import { getNodeDataList, getNodeDataListHead, getNodeDataListInfo, putAbnormaltroubleshoot, compareImages, submitPictureFun, getCompareImages, uploadPicExAPI } from '@/server/risk'
import ShowImgs from './showImg.js'
import { debounce } from '@/common/js/common.js'
const { TabPane } = Tabs;

function RecordRoutineInfo () {
  const { message } = App.useApp();
  const Stateparams = useLocation();
  const transfer = Stateparams.state;
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const {
    token: { colorText, colorTextTertiary, colorBorderSecondary },
  } = theme.useToken(); //获取主题颜色
  const token = localStorage.getItem('dock_token') || ''
  const autoRefreshRef = useRef()//自动刷新  计时器
  const uploadImgRef = useRef() // 上传图片

  const [loading, setLoading] = useState(false)//加载中···
  const [imgsLoading, setImgsLoading] = useState(false)//加载中···
  const [imgWidth, setImgWidth] = useState(0);//图片宽度
  const [tabsData, setTabsData] = useState([])//当前tabs列表数据
  const [pictureData, setPictureData] = useState([]) //获取的数据
  const [mouseInIdx, setMouseInIdx] = useState(-1)//鼠标移入的图片idx
  const [mouseInInfo, setMouseInInfo] = useState([]);//鼠标移入后展示的图片数据

  const [curSeeImg, setCurSeeImg] = useState({//当前需要查看的图片列表信息
    open: false,//图片查看  是否打开
    type: -1,//当前需要查看的图片类型   1：缩略图   2：原图
    curClickIdx: -1,//当前点击的图片下标
    isLiftPage: true,//当前是否有上一张图片
    isRightPage: true,//当前是否有下一张图片
  })

  const [isCheckAutoRefresh, setIsCheckAutoRefresh] = useState(false);//是否选中  自动刷新
  const [AirportPermissionsArr, setAirportPermissionsArr] = useState([])//权限列表id
  const [AirportPermissionsArrName, setAirportPermissionsArrName] = useState([])//权限列表name
  const searchPage = useRef(1)//当前选中的页码
  const searchcheck = useRef(0)//当前选中的类型
  const isNextPage = useRef(false)//是否还有下一页
  const curSeeImgOpenRef = useRef(false)//是否打开图片查看组件
  const curClickIdxRef = useRef(-1)//当前点击图片下标
  const [searchList, setSearchList] = useState({//搜索列表
    check: 0,
    total: 0,
    page: 1,
    perpage: 12,
  })

  const [contrastData, setContrastData] = useState({//对比图片
    isOpen: false,
    name: '',
    img1: '',
    img2: '',
    time1: '',
    time2: '',
  })

  const [uploadPhoto, setUploadPhoto] = useState({//上传图片 所需id列表
    insID: -1,
    pointID: -1,
    key: -1,
  })

  const [imgsArrList, setImgsArrList] = useState({//图片数组集合
    thumbnail: [],//缩略图
    originalDrawing: [],//原图
  })

  const [adviceDrawer, setAdviceDrawer] = useState({ //处理意见弹窗
    isOpen: false,//是否打开
    address: '',//地址
    pointOrder: '',//序号
    date: '',//日期
    divrisk: [],//风险
    userName: [],//处理人员
    advice: [],//处理意见
  });

  const [showImgInfo, setShowImgInfo] = useState({ //显示处理意见图片信息
    visible: false,
    current: 1,
    urls: [],
  });

  const getImgsRecordList = async (c) => {//获取图片记录的tabs列表
    let obj = {
      access_token: token,
      companyId: transfer.companyId,
      statid: transfer.statid,
      insIds: transfer.insIds,
    }
    let res = await getNodeDataListHead(obj)
    if (res.ret !== 200) { message.warning(res.msg || '系统出错了，请稍后再试！'); return }

    const data = []
    if (res.data.length > 0) {
      res.data.forEach(item => {
        item.is_point = false
        if (Number(item.total) >= 0) { data.push(item) }
      })
    }
    setTabsData(data || [])
    return c(data[0]?.value);
  }

  const getImgsData = async (value, search, type = null) => {//获取图片记录数据
    setMouseInInfo([])
    let obj = {
      access_token: token,
      companyId: transfer.companyId,
      statid: transfer.statid,
      insIds: transfer.insIds,
      point_status: value || searchcheck.current,
      page: search.page,
      perpage: search.perpage,
    }
    let res = await getNodeDataList(obj)
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了~'); setLoading(false); setImgsLoading(false); return }

    if (searchPage.current !== res.data.page) {//判断 获取到的页码是否与当前页码相同
      return
    }

    let sea = searchList
    sea.page = search.page
    sea.total = res.data.total
    sea.perpage = search.perpage
    sea.check = searchcheck.current
    setSearchList({ ...sea })

    let num = 0 //计数
    let list = res.data.items.map((res, index) => {
      if (res.handler_status !== 0) {
        let obj = {
          ...res,
          key: index,
          idx: num,
          divrisk: [],//风险
          userName: [],//处理人名称
          adviceDiv: [],//详情信息
          adviceState: null
        }
        num += 1
        return obj
      } else {
        return {
          ...res,
          key: index,
          idx: -1,
          divrisk: [],
          userName: [],
          adviceDiv: [],
          adviceState: null
        }
      }

    })
    setPictureData([...list])
    // 图片数组集合
    let img = imgsArrList
    let thu = []
    let ori = []
    res.data.items.forEach((res) => {
      if (res.handler_status !== 0) {
        thu.push(res.picUrl)
      }
    })
    res.data.items.forEach((res) => {
      if (res.handler_status !== 0) {
        ori.push(res.original_picUrl)
      }
    })
    img.thumbnail = thu
    img.originalDrawing = ori
    setImgsArrList({ ...img })

    let cur = curSeeImg
    if (type === 'ArrowLeft') {
      cur.curClickIdx = cur.type === 1 ? thu.length - 1 : ori.length - 1
      curClickIdxRef.current = cur.type === 1 ? thu.length - 1 : ori.length - 1
    }
    if (type === 'ArrowRight') {
      cur.curClickIdx = 0
      curClickIdxRef.current = 0
    }
    isNextPage.current = searchPage.current < Math.ceil(sea.total / sea.perpage)
    setCurSeeImg({ ...cur })
    setLoading(false)
    setImgsLoading(false)
  }

  const getSingleImgInfo = async (companyID, statid, pointId, idx) => { //获取单个图片的详细信息
    let obj = {
      access_token: token,
      companyId: companyID,
      statid: statid,
      pointId: pointId,
    }
    let res = await getNodeDataListInfo(obj)
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了~'); return }
    let val = res.data;
    let info = {
      divrisk: [],//风险
      userName: [],//处理人名称
      advice: false,//处理意见是否显示 查看详情
      adviceList: [],//处理意见
    }
    let arr = val.abnormal_type_str ? val.abnormal_type_str.split("，") : [];
    info.divrisk = arr.length > 0 ? arr : <div className='opa25'>-</div>;
    info.userName = val.handler_user_name ? val.handler_user_name.split(",") : [];;

    if (val.list.length > 0) {
      info.advice = true;
      info.adviceList = val.list.map((item, i) => {
        let imgs = item.detail_pic ? item.detail_pic : [];
        let detailList = item.detail ? item.detail.split('\n') : [];
        return (
          <div className='margB12' key={i}>
            <div className='flex-row'>
              <Tag style={{
                background: "#262626", borderRadius: 3,
                display: (item.status === 1) ? 'block' : 'none'
              }} className='marB4'>处理完毕</Tag>
            </div>
            <div className='flex_row' style={{ display: imgs.length > 0 ? '' : 'none', }}>
              <img alt='处理拍照1' src={imgs[0] ? imgs[0] : ''} className='w64 h64 marR8 pointer radius8 flex_shrink0' style={{ objectFit: 'cover', display: imgs[0] ? '' : 'none' }}
                onClick={() => { showAdviceImg(0, item) }}>
              </img>
              <img alt='处理拍照2' src={imgs[1] ? imgs[1] : ''} className='w64 h64 marR8 pointer radius8 flex_shrink0' style={{ objectFit: 'cover', display: imgs[1] ? '' : 'none' }}
                onClick={() => { showAdviceImg(1, item) }}>
              </img>
              <img alt='处理拍照3' src={imgs[2] ? imgs[2] : ''} className='w64 h64 marR8 pointer radius8 flex_shrink0' style={{ objectFit: 'cover', display: imgs[2] ? '' : 'none' }}
                onClick={() => { showAdviceImg(2, item) }}>
              </img>
            </div>
            {
              detailList.map((detailItem, detailIndex) => {
                return <div style={{ wordBreak: 'break-word' }} key={detailIndex}>{detailItem}</div>
              })
            }
            <div className='' style={{ color: colorTextTertiary }}>{item.addtime + ' ' + item.realname}</div>
          </div>
        )
      })
    } else {
      if (val.handler_status === 3 || val.handler_status === 4) {
        info.adviceList = <div>忽略</div>;
      } else {
        info.adviceList = <div className='margB12 opa25'>-</div>;
      }
    }


    let mou = mouseInInfo
    mou[idx] = true
    setMouseInInfo(mou);

    let pic = pictureData
    pic[idx].divrisk = info.divrisk;
    pic[idx].userName = info.userName;
    pic[idx].adviceDiv = info.adviceList;
    pic[idx].adviceState = info.advice;
    setPictureData(pic);
  }

  //显示处理意见图片
  const showAdviceImg = (cur, data = '') => {
    let info = { ...showImgInfo };
    info.visible = true;
    if (data) { //多个图片
      info.current = cur;
      info.urls = data.detail_pic ? data.detail_pic : [];

    } else { //单个图片
      info.urls = [cur];
      info.current = 0;
    }
    setShowImgInfo(info);
  }

  const refreshOnChange = (e) => {//自动刷新改变执行
    if (e) {
      autoRefreshRef.current = setInterval(() => {
        getImgsRecordList((val) => {
          getImgsData(val, searchList)
        })
      }, 3000);
    } else {
      clearInterval(autoRefreshRef.current)
    }
  }

  const onPatrolMap = (item) => {//查看图片所在地图位置
    const coordinate = {
      picUrl: item.picUrl,
      longitude: item.longitude, //经度
      latitude: item.latitude, //纬度
    }
    let d = transformGCJ2WGS({ lat: coordinate.latitude, lon: coordinate.longitude });
    coordinate.latitude = Number(parseFloat(d.lat).toFixed(7));
    coordinate.longitude = Number(parseFloat(d.lon).toFixed(7));
    window.sessionStorage.setItem('PatrolMap?id=rr' + item.pointId, JSON.stringify(coordinate))
    window.open(basicPath + '/PatrolMap?id=rr' + item.pointId, '_blank')
  }

  const getCompareImage = async (pid) => { //获取图片对比数据
    let con = contrastData
    let res = null;
    if (Number(transfer.search.urlType) === 8 || Number(transfer.search.urlType) === 9) {
      res = await getCompareImages({ access_token: token, pointId: pid })
    } else {
      res = await compareImages({ access_token: token, pointId: pid })
    }
    if (res.ret === 200) {
      if (res.data && res.data.oldPic && res.data.newPic) {
        con.img1 = res.data.oldPic
        con.img2 = res.data.newPic
        con.time1 = res.data.oldtime
        con.time2 = res.data.newtime
        con.isOpen = true
        setContrastData({ ...con })
      } else {
        message.warning('暂无对比图片！')
      }
    } else {
      message.warning(res.msg || '系统错误~')
    }
  }

  const submitPicture = async (file) => {//上传图片
    setLoading(true)
    let res = await submitPictureFun({
      access_token: token,
      insID: uploadPhoto.insID,
      pointID: uploadPhoto.pointID,
      file: file
    });
    setLoading(false)
    uploadImgRef.current.value = ''
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了~'); return }
    message.success('上传成功');
    let list = [...pictureData]
    list[uploadPhoto.key].picUrl = res.data.picUrl || 'xxxxxxxxxxxxx'
    list[uploadPhoto.key].handler_status = 0
    setPictureData(list)
  }

  const getImgFatherWidth = () => {    //获取图片父级宽度 以及 对应图片宽度
    setTimeout(() => {
      let dom = document.getElementById('imgFather');
      let width = dom.clientWidth;
      // setImgFatherWidth(width);
      setImgWidth(Number((width * 0.24).toFixed(2)));
    }, 200);
  }

  useEffect(() => {
    setLoading(true)
    getImgsRecordList((val) => {
      getImgsData(val, searchList)
    })
    setAirportPermissionsArr([...JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'))])
    setAirportPermissionsArrName([...JSON.parse(localStorage.getItem('dock_AirportPermissionsArrName'))])

    // 计算高宽
    getImgFatherWidth();
    window.addEventListener('resize', getImgFatherWidth);
    return () => {
      clearInterval(autoRefreshRef.current)
      window.removeEventListener('resize', getImgFatherWidth);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {/* 头部 */}
      <div className="flex jcsb">
        {/* 信息栏 */}
        <div className='flex_row align_center pdL24' style={{ width: '100% ', padding: '16px 24px' }}>
          <div
            className='curPointer'
            onClick={() => {
              if (transfer.search) {
                switch (transfer.search.urlType) {
                  case 1:
                    navigate('/routine_record_conduit', { state: transfer });
                    break;
                  case 7:
                    navigate('/routine_record_powerGrid', { state: transfer });
                    break;
                  case 8:
                    navigate('/fixedPoint_record_electricTower', { state: transfer });
                    break;
                  case 9:
                    navigate('/fixedPoint_record_station', { state: transfer });
                    break;
                  default:
                    break;
                }
              } else {
                navigate(-1)
              }
            }}
          >
            <ArrowLeftOutlined />
          </div>
          <span className='fs20 fw500 margR12 margL18'>
            {transfer.title ? transfer.title : '-'}
          </span>
          <div className='fs14 fw400 opacity0_45'>
            巡检时间：
            {transfer.start_time} ~ <span>{transfer.end_time !== '' ? transfer.end_time : '未结束'}
            </span>
          </div>
        </div>

        {/* 自动刷新 */}
        <div
          className=' marTB16  marR24 align_center flex'
          style={{ display: AirportPermissionsArrName.indexOf(`InsImageList_PointList_${transfer.search.urlType}`) > -1 ? `` : `none` }}
        >
          <Checkbox
            checked={isCheckAutoRefresh}
            className='w110'
            onChange={(e) => {
              setIsCheckAutoRefresh(e.target.checked)
              refreshOnChange(e.target.checked)
            }}
          >
            自动刷新/3s
          </Checkbox>
        </div>
      </div>

      {/* 主体 */}
      <Card className='marRL24 marB24' style={{ border: 0 }}>
        {/* 头部标签页 */}
        <Tabs defaultActiveKey={searchList.check}>
          {
            tabsData.map((item, index) => {
              return (
                <TabPane
                  key={index}
                  tab={
                    <div className='disFlex align_center' key={index} onClick={() => {
                      setLoading(true)
                      let sea = searchList
                      sea.page = 1
                      sea.check = item.value
                      searchcheck.current = item.value
                      setSearchList({ ...sea })
                      getImgsData('', sea)
                    }}
                    >
                      <div className='margR4'>
                        {item.label}
                      </div>
                      <div className='TabPane' >
                        {item.total}
                      </div>
                    </div>
                  }
                >
                </TabPane>
              )
            })
          }
        </Tabs>

        {/* 图片列表 */}
        <div className='hidden radius8' style={{ maxHeight: 'calc(100vh - 246px)', overflowY: 'auto' }}>
          <Spin spinning={loading}>

            <div className="flex flex_wrap" id='imgFather'
              style={{ flexDirection: 'row', maxHeight: '100%', overflowY: 'auto', alignContent: 'flex-start' }}>
              {pictureData.length > 0
                ?
                pictureData.map((item, item_idx) => {
                  return (
                    item.handler_status === 0
                      ? (
                        <div
                          key={item_idx}
                          className="flex_col"
                          style={{ width: '24%', height: 'auto', marginBottom: '24px', marginRight: '1%', }}
                        >
                          <div>
                            {
                              !item.picUrl && AirportPermissionsArr.indexOf(132) >= 0
                                ?
                                //没有图片
                                <div>
                                  <div className='pos_rel radius8' style={{ backgroundColor: '#000' }}>
                                    <img className='radius8' style={{ width: '100%' }} src={ai_processing} alt="人工复核中..." />
                                    {/* 覆盖图层  显示想要显示的文字  且 重新上传图片  + */}
                                    <div
                                      className='pos_abs wid100 hei100 flex jcc align_center radius8 pointer'
                                      style={{ backgroundColor: '#000', top: 0, left: 0 }}
                                      onClick={async () => {
                                        if (AirportPermissionsArr.indexOf(132) < 0) { return; }
                                        setLoading(true)
                                        let res = await uploadPicExAPI({ access_token: token, pointID: item.pointId })
                                        if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了~'); setLoading(false); return; }
                                        if (res.data) {
                                          getImgsRecordList((val) => { getImgsData(val, searchList) })
                                        } else {
                                          let upl = uploadPhoto;
                                          upl.insID = item.insIds;
                                          upl.pointID = item.pointId;
                                          upl.key = item.key;
                                          setUploadPhoto({ ...upl });
                                          uploadImgRef.current.click();
                                        }
                                      }}
                                    >
                                      <PlusOutlined className='fs50' style={{ opacity: 0.25 }} />
                                    </div>
                                  </div>

                                  <div className="flex jcsb marT8" style={{ flexDirection: 'row', flex: 'auto', }}>
                                    <div className='coLF0_85' style={{ fontSize: '14px', fontWeight: '600' }}>
                                      {item.point_order}
                                    </div>

                                    {/* 按钮 */}
                                    <div className='flex align_center'>
                                      <Button size='small' className='marR8' style={{ display: AirportPermissionsArrName.indexOf(`Upload_Pic_${transfer.search.urlType}`) >= 0 ? '' : 'none' }}
                                        onClick={() => {
                                          let upl = uploadPhoto
                                          upl.insID = item.insIds
                                          upl.pointID = item.pointId
                                          upl.key = item.key
                                          setUploadPhoto({ ...upl })
                                          uploadImgRef.current.click();
                                        }}
                                      >
                                        上传
                                      </Button>

                                      <Button
                                        style={{ display: item.is_contrast === 1 ? '' : 'none' }}
                                        size='small'
                                        className='marR8'
                                        onClick={() => {
                                          let con = contrastData;
                                          con.name = item.point_order;
                                          setContrastData({ ...con });
                                          getCompareImage(item.pointId);
                                        }}
                                      >
                                        对比
                                      </Button>
                                      {
                                        item.original_picUrl
                                          ? (
                                            <Tag
                                              color="processing"
                                              className='pointer h24'
                                              onClick={() => {
                                                let cur = curSeeImg
                                                cur.type = 2
                                                cur.open = true
                                                curSeeImgOpenRef.current = true
                                                cur.curClickIdx = item.idx
                                                curClickIdxRef.current = item.idx
                                                setCurSeeImg({ ...cur })
                                              }}
                                            >
                                              原图
                                            </Tag>
                                          )
                                          : ''

                                      }
                                      <div style={{ fontSize: '14px', fontWeight: '400', color: '#1890FF', cursor: 'pointer' }}
                                        onClick={() => { onPatrolMap(item) }}>
                                        <EnvironmentFilled style={{ color: '#177DDC' }} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                :
                                <div>
                                  <div className='pos_rel radius8' style={{ backgroundColor: '#000' }}>
                                    <img className='radius8' style={{ width: '100%', opacity: 1 }} src={ai_processing} alt="人工复核中..." />
                                    {/* 覆盖图层  显示想要显示的文字 */}
                                  </div>
                                  <div className="flex jcsb marT8" style={{ flexDirection: 'row', flex: 'auto', }}>
                                    <div className='coLF0_85' style={{ fontSize: '14px', fontWeight: '600' }}>
                                      {item.point_order}
                                    </div>

                                    {/* 按钮 */}
                                    <div className='flex align_center'>
                                      <Button
                                        size='small'
                                        className='marR8'
                                        style={{ display: (AirportPermissionsArrName.indexOf(`Upload_Pic_${transfer.search.urlType}`) >= 0) || Number(localStorage.getItem('dock_memberLevel')) === 255 ? '' : 'none' }}
                                        onClick={() => {
                                          let upl = uploadPhoto
                                          upl.insID = item.insIds
                                          upl.pointID = item.pointId
                                          upl.key = item.key
                                          setUploadPhoto({ ...upl })
                                          uploadImgRef.current.click();
                                        }}
                                      >
                                        上传
                                      </Button>

                                      <Button
                                        style={{ display: item.is_contrast === 1 ? '' : 'none' }}
                                        size='small'
                                        className='marR8'
                                        onClick={() => {
                                          let con = contrastData;
                                          con.name = item.point_order;
                                          setContrastData({ ...con });
                                          getCompareImage(item.pointId);
                                        }}
                                      >
                                        对比
                                      </Button>
                                      {
                                        item.original_picUrl
                                          ? (
                                            <Tag
                                              color="processing"
                                              className='pointer h24'
                                              onClick={() => {
                                                let cur = curSeeImg
                                                cur.type = 2
                                                cur.open = true
                                                curSeeImgOpenRef.current = true
                                                cur.curClickIdx = item.idx
                                                curClickIdxRef.current = item.idx
                                                setCurSeeImg({ ...cur })
                                              }}
                                            >
                                              原图
                                            </Tag>
                                          )
                                          : ''
                                      }
                                      <div style={{ fontSize: '14px', fontWeight: '400', color: '#1890FF', cursor: 'pointer' }}
                                        onClick={() => { onPatrolMap(item) }}>
                                        <EnvironmentFilled style={{ color: '#177DDC' }} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            }
                          </div>
                        </div>
                      )
                      : (
                        <div
                          key={item_idx}
                          className="flex_col"
                          style={{ width: '24%', height: 'auto', marginBottom: '24px', marginRight: '1%' }}
                        >
                          {/* 图片 */}
                          <div
                            className='pos_rel'
                            onMouseLeave={() => setMouseInIdx(-1)}
                            onMouseEnter={() => {
                              if (!mouseInInfo[item_idx]) {
                                getSingleImgInfo(item.CompanyID, item.statid, item.pointId, item_idx);
                              }
                              setMouseInIdx(item_idx);
                            }}
                          >
                            <span><ImageCom alt='index' height={Number((imgWidth * 3 / 4).toFixed(2))} borderRadius={8} src={item.picUrl} errorBackground='#000000' /></span>

                            {/* 蒙层 */}
                            <div className='pos_abs radius8 wid100 hei100 paddRL24 paddTB16'
                              style={{ background: 'rgba(0, 0, 0, 0.45)', top: 0, left: 0, overflowY: 'auto', display: item_idx === mouseInIdx ? '' : 'none' }}
                              onClick={() => {
                                let allImgs = curSeeImg.type === 1 ? imgsArrList.thumbnail.length : imgsArrList.originalDrawing.length
                                let cur = curSeeImg
                                cur.type = 1
                                cur.open = true
                                curSeeImgOpenRef.current = true
                                cur.curClickIdx = item.idx
                                curClickIdxRef.current = item.idx
                                cur.isLiftPage = (searchPage.current > 1 || (searchPage.current === 1 && item.idx !== 0))
                                cur.isRightPage = (isNextPage.current || cur.curClickIdx < (allImgs - 1))
                                setCurSeeImg({ ...cur })
                              }}
                            >
                              <div className='fSize14 fWei400 margB8 flex-row' style={{ display: item.location ? `` : `none` }}>
                                <div className='flex_shrink0'>
                                  位置：
                                </div>
                                <div>
                                  {item.location}
                                </div>
                              </div>
                              <div className='fSize14 fWei400 margB8 flex-row'>
                                <div className='flex_shrink0'>
                                  时间：
                                </div>
                                <div className=''>
                                  {item.addtime}
                                </div>
                              </div>

                              <div className='fSize14 fWei400 margB8 flex-row' style={{ display: item.abnormal_type === '1' ? 'none' : '' }}>
                                <div className='flex_shrink0'>
                                  处理：{item.adviceState}
                                </div>
                                <>
                                  {
                                    item.adviceState === null ? <div></div>
                                      : item.adviceState ?
                                        <div
                                          style={{ color: '#69c0ff' }}
                                          className='pointer'
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            let info = { ...adviceDrawer };
                                            info.isOpen = true;
                                            info.address = item.location;
                                            info.pointOrder = item.point_order;
                                            info.date = item.addtime;
                                            info.divrisk = item.divrisk;
                                            info.userName = item.userName;
                                            info.advice = item.adviceDiv;
                                            setAdviceDrawer(info);
                                          }}>
                                          详情
                                        </div>
                                        : <div className='opa25'>-</div>
                                  }
                                </>
                              </div>
                            </div>

                            {/* 甲烷值 */}
                            <div className='coLF0_85 backColorD32029 borRad2' style={{ position: 'absolute', bottom: '32px', right: '8px', padding: '1px 8px', display: (item.methane_con > -1 ? 'none' : 'none') }}>
                              CH4：{item.methane_con} ppm·m
                            </div>
                          </div>

                          {/* 按钮集 */}
                          <div className="flex jcsb marT8"
                            style={{ flexDirection: 'row', flex: 'auto', }}>
                            {/* 文字 */}
                            <div className='coLF0_85' style={{ fontSize: '14px', fontWeight: '600' }}>
                              {
                                transfer.search.urlType === 6 && searchList.check === 7
                                  ? item.addtime
                                  : item.point_order
                              }
                            </div>

                            {/* 按钮 */}
                            <div className='flex align_center'>
                              <Button size='small' className='marR8' style={{ display: AirportPermissionsArrName.indexOf(`Upload_Pic_${transfer.search.urlType}`) >= 0 ? '' : 'none' }}
                                onClick={() => {
                                  let upl = uploadPhoto
                                  upl.insID = item.insIds
                                  upl.pointID = item.pointId
                                  upl.key = item.key
                                  setUploadPhoto({ ...upl })
                                  uploadImgRef.current.click();
                                }}
                              >
                                上传
                              </Button>

                              <Button
                                style={{ display: item.is_contrast === 1 ? '' : 'none' }}
                                size='small'
                                className='marR8'
                                onClick={() => {
                                  let con = contrastData;
                                  con.name = item.point_order;
                                  setContrastData({ ...con });
                                  getCompareImage(item.pointId);
                                }}
                              >
                                对比
                              </Button>
                              {
                                item.original_picUrl
                                  ? (
                                    <Tag
                                      color="processing"
                                      className='pointer h24'
                                      onClick={() => {
                                        let cur = curSeeImg
                                        cur.type = 2
                                        cur.open = true
                                        curSeeImgOpenRef.current = true
                                        cur.curClickIdx = item.idx
                                        curClickIdxRef.current = item.idx
                                        setCurSeeImg({ ...cur })
                                      }}
                                    >
                                      原图
                                    </Tag>
                                  )
                                  : ''

                              }
                              <div style={{ fontSize: '14px', fontWeight: '400', color: '#1890FF', cursor: 'pointer' }}
                                onClick={() => { onPatrolMap(item) }}>
                                <EnvironmentFilled style={{ color: '#177DDC' }} />
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )
                })
                : <div className='flex jcc wid100'><Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>}
            </div>

            {/* 分页 */}
            <div className='flex jcr Pagination'>
              <Pagination
                align='end'
                total={searchList.total}
                current={searchList.page}
                pageSize={searchList.perpage}
                showQuickJumper
                showSizeChanger={true}
                pageSizeOptions={['12', '24', '48', '96',]}
                showTotal={(total) => `Total ${total} items`}
                onChange={(page, pageSize) => {
                  setLoading(true)
                  clearInterval(autoRefreshRef.current);
                  let sea = searchList
                  sea.page = page
                  searchPage.current = page
                  sea.perpage = pageSize
                  setSearchList({ ...sea })
                  getImgsData('', sea)
                  refreshOnChange(isCheckAutoRefresh)
                }}
              />
            </div>
          </Spin>
        </div>



        <>{/* 图片查看组件 */}
          <ShowImgs
            arrData={pictureData}
            picData={curSeeImg.type === 1 ? imgsArrList.thumbnail : imgsArrList.originalDrawing}
            imgIdx={curSeeImg.curClickIdx}
            open={curSeeImg.open}
            loading={imgsLoading}
            imgBackChange={async (e) => {
              let res = await putAbnormaltroubleshoot({
                access_token: token,
                pointId: e,
              })
              if (res.ret === 200) {
                pictureData.find((res) => res.pointId === e).handler_status = 0
                let cur = curSeeImg
                cur.open = false
                curSeeImgOpenRef.current = false
                setCurSeeImg({ ...cur })
                getImgsRecordList((val) => {
                  getImgsData(val, searchList)
                })
              }
            }}
            pageChange={debounce((e) => {//上一页、下一页回调
              let cur = curSeeImg
              let sea = searchList
              let allImgs = curSeeImg.type === 1 ? imgsArrList.thumbnail.length : imgsArrList.originalDrawing.length
              if (e < 0 || e > (allImgs - 1)) {

                if (e < 0 && searchPage.current > 1) {//加载上一页
                  cur.curClickIdx = -1
                  curClickIdxRef.current = -1
                  sea.page -= 1
                  searchPage.current -= 1
                  setImgsLoading(true)
                  getImgsData(sea.check, sea, 'ArrowLeft')
                }

                if (e > (allImgs - 1) && isNextPage.current) {//加载下一页
                  cur.curClickIdx = -1
                  curClickIdxRef.current = -1
                  sea.page += 1
                  searchPage.current += 1
                  setImgsLoading(true)
                  getImgsData(sea.check, sea, 'ArrowRight')
                }
              } else {
                cur.curClickIdx = e
                curClickIdxRef.current = e
                cur.isLiftPage = (cur.curClickIdx !== 0 || sea.page > 1)
                cur.isRightPage = (isNextPage.current || cur.curClickIdx < (allImgs - 1))
              }
              setSearchList({ ...sea })
              setCurSeeImg({ ...cur })
            }, 500)}
            closeChange={(vis) => {
              let cur = curSeeImg; cur.open = vis; curSeeImgOpenRef.current = vis; setCurSeeImg({ ...cur })
            }}
            isLiftPage={curSeeImg.isLiftPage}
            isRightPage={curSeeImg.isRightPage}
          />
        </>

        <>{/* 风险处理详情抽屉 */}

          <Drawer title='处理详情' width={256} placement="right" onClose={() => {
            let info = { ...adviceDrawer };
            info.isOpen = false;
            setAdviceDrawer(info);
          }} open={adviceDrawer.isOpen}>
            {/* 信息 */}
            <div className='flex_col'>
              <div className='lh20 pdB16'
                style={{ borderBottom: '1px solid ' + colorBorderSecondary }}
              >
                <div className='col_primary fw500'>{adviceDrawer.address}</div>
                <div className='' style={{ color: colorTextTertiary }}>{adviceDrawer.pointOrder}</div>
                <div className='' style={{ color: colorTextTertiary }}>{adviceDrawer.date}</div>
              </div>
              {/* 风险初判 */}
              <div className='flex_col pdB16 col_divider_w_top'>
                <div
                  className='marTB12'
                  style={{ borderBottom: '1px solid ' + colorBorderSecondary }}
                >
                  <div className='lh22' style={{ color: colorTextTertiary }}>风险初判</div>
                  <div className='flex_row flex_wrap marB4'>
                    {
                      adviceDrawer.divrisk.length > 0
                        ? (
                          adviceDrawer.divrisk.map((item, idx) => {
                            return (
                              <Tag
                                key={idx}
                                color="error"
                                className='marR8 marB8'
                              >
                                {item}
                              </Tag>
                            )
                          })
                        )
                        : (
                          <div className='opa25 marB8'>-</div>
                        )
                    }
                  </div>
                </div>

                {/* 处理人员 */}
                <div
                  className='marB12'
                  style={{ borderBottom: '1px solid ' + colorBorderSecondary }}
                >
                  <div className='lh22' style={{ color: colorTextTertiary }}>处理人员</div>
                  <div className='marB12'>
                    {
                      adviceDrawer.userName.length > 0
                        ?
                        <div
                          style={{ color: 'rgba(255,255,255,0.85)' }}
                          className='lh20'
                        >
                          {adviceDrawer.userName.join('、')}
                        </div>
                        : <div className='opa25'>-</div>
                    }
                  </div>
                </div>

                {/* 处理意见 */}
                <div>
                  <div className='marB12 lh22' style={{ color: colorTextTertiary }}> 处理意见 </div>
                  <div className='flex_col lh20' style={{ color: 'rgba(255,255,255,0.85)' }}>
                    {adviceDrawer.advice}
                  </div>
                </div>
              </div>
            </div>
          </Drawer>
        </>

        <>{/* 对比图片 */}
          < Modal width='90vw' wrapClassName='dd_modal' open={contrastData.isOpen} destroyOnClose={true}
            title={contrastData.name} footer={null}
            onCancel={() => {
              let con = contrastData
              con.isOpen = false
              setContrastData({ ...con })
            }}
          >
            <div className='flex jcsb' style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
              <div style={{ width: 'calc(50% - 12px)' }}>
                <img alt='图片对比1' className='wid100' src={contrastData.img1} />
                <div>
                  <span>{contrastData.time1}</span>
                </div>
              </div>
              <div className='w24'></div>
              <div style={{ width: 'calc(50% - 12px)' }}>
                <img alt='图片对比2' className='wid100' src={contrastData.img2} />
                <div>
                  <span>{contrastData.time2}</span>
                </div>
              </div>
            </div>
          </Modal>
        </>

        <>{/* 上传图片 */}
          <div style={{ display: 'none' }}>
            <input ref={uploadImgRef} type='file' accept="image/png, image/jpeg" onChange={(e) => {
              let file = e.target.files[0];
              if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                uploadImgRef.current.value = '';
                return message.error('只能上传jpeg/png格式的图片');
              }
              if (file.size > 50 * 1024 * 1024) {
                uploadImgRef.current.value = '';
                return message.error('图片不能超过50M');
              }
              submitPicture(file);
            }}
            />
          </div>
        </>



        <>{/* 图片放大 */}
          <Image.PreviewGroup
            preview={{
              visible: showImgInfo.visible,
              current: showImgInfo.current,
              onVisibleChange: (value) => {
                let info = { ...showImgInfo };
                info.visible = false;
                info.urls = [];
                info.current = 0;
                setShowImgInfo(info);
              },
              onChange: (e) => {
                let info = { ...showImgInfo };
                info.current = e;
                setShowImgInfo(info);
              }
            }}
            items={showImgInfo.urls}
          >
          </Image.PreviewGroup>
        </>


      </Card>
    </>
  )
}
export default RecordRoutineInfo;